import Taxes from '../../../../../elements/Taxes'
import React from 'react'
import { Checkbox, Col, DatePicker, Form, Row } from 'antd'
import { get } from 'lodash'
import { dateVal } from '../../../../../modules/Utils'
import InfoTooltip from '../../../../../elements/InfoTooltip'
import { defaultFormItemLayout } from '../../../../../modules/FormItems'
import { compose } from 'recompose'
import withSelectFetch from '../../../../../elements/Select/withSelectFetch'
import withSpinning from '../../../../../elements/HOC/withSpinning'
import withSubDropdown from '../../../../../elements/HOC/withSubDropdown'
import withSort from '../../../../../elements/HOC/withSort'
import CustomSelect from '../../../../../elements/Select/CustomSelect'

const CreditTerms = compose(
  withSelectFetch({ dropdown: 'client', name: 'terms' }),
  withSpinning,
  withSubDropdown({ name: 'credit' }),
  withSort,
)(CustomSelect)
const FormItem = Form.Item

function KeyTerms (props) {
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = props.form
  const { contract } = props

  return (
    <Form layout="horizontal">
      <Row>
        <Col span={12}>
          <FormItem label="Contract Date" {...defaultFormItemLayout}>
            {getFieldDecorator('date.start', {
              initialValue: dateVal(contract, 'date.start'),
              rules: [
                {
                  required: true,
                  message: 'Contract Date can\'t be empty ',
                },
              ],
            })(<DatePicker style={{ width: '100%' }} placeholder="Contract Date"/>)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem
            label={<InfoTooltip value={'Effective Date'} title={'Default service start date'}/>}
            {...defaultFormItemLayout}>
            {getFieldDecorator('date.effective', {
              initialValue: dateVal(contract, 'date.effective'),
              rules: [
                {
                  required: true,
                  message: 'Effective Date can\'t be empty ',
                },
              ],
            })(<DatePicker style={{ width: '100%' }} placeholder="Effective Date"/>)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="Contract End Date" {...defaultFormItemLayout}>
            {getFieldDecorator('date.expiry', {
              initialValue: dateVal(contract, 'date.expiry'),
            })(<DatePicker style={{ width: '100%' }} placeholder="Contract End Date"/>)}
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <FormItem label="Credit Terms" {...defaultFormItemLayout}>
            {getFieldDecorator('terms.credit', {
              initialValue: get(contract, 'terms.credit'),
              rules: [
                {
                  required: true,
                  message: 'Credit Terms can\'t be empty ',
                },
              ],
            })(<CreditTerms placeholder="Credit Terms"/>)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="Notice To Proceed" {...defaultFormItemLayout}>
            {getFieldDecorator('terms.noticeToProceed', {
              initialValue: get(contract, 'terms.noticeToProceed'),
              valuePropName: 'checked',
              /*rules: [
                {
                  //required: true,
                  message: 'Notice To Proceed can\'t be empty ',
                },
              ],*/
            })(<Checkbox placeholder="Notice To Proceed"/>)}
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Taxes
          doc={{
            taxType: get(contract, 'terms.applicableTax') ? 'inc-tax' : 'ex-tax',
            ...contract,
          }}
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            resetFields,
            type: 'salesContract',
            hideRate: true,
          }}
        />
      </Row>
    </Form>
  )
}

export default Form.create()(KeyTerms)
